import React from 'react';
import PropTypes from 'prop-types';
import { Box, ExtendedBox } from '../..';

import TabFilter from './components/TabFilter';
import SelectFilter from './components/SelectFilter';

const ResponsiveFilter = ({
  filterItems,
  selectedFilterValue,
  updateSelectedFilterValue,
  type,
  id,
}) => {
  const types = {
    both: () => (
      <Box
        px={[40, 20, 20, 20, 0]}
        pt={[20, 40]}
        style={{
          maxWidth: '100%',
        }}
      >
        <ExtendedBox
          display={['none', 'none', 'none', 'block']}
        >
          <TabFilter
            id={id}
            filterItems={filterItems}
            selectedFilterValue={selectedFilterValue}
            updateSelectedFilterValue={updateSelectedFilterValue}
          />
        </ExtendedBox>
        <ExtendedBox
          display={['block', 'block', 'block', 'none']}
        >
          <SelectFilter
            id={id}
            filterItems={filterItems}
            selectedFilterValue={selectedFilterValue}
            updateSelectedFilterValue={updateSelectedFilterValue}
          />
        </ExtendedBox>
      </Box>
    ),
    selectOnly: () => (
      <Box
        px={[40, 20]}
        pt={[20, 40]}
      >
        <SelectFilter
          id={id}
          filterItems={filterItems}
          selectedFilterValue={selectedFilterValue}
          updateSelectedFilterValue={updateSelectedFilterValue}
        />
      </Box>
    ),
    tabsOnly: () => (
      <Box
        w={1}
        px={[40, 20]}
        pt={[20, 40]}
      >
        <TabFilter
          filterItems={filterItems}
          id={id}
          selectedFilterValue={selectedFilterValue}
          updateSelectedFilterValue={updateSelectedFilterValue}
        />
      </Box>
    ),
  };
  return types[type]();
};

ResponsiveFilter.propTypes = {
  filterItems: PropTypes.arrayOf(PropTypes.object),
  selectedFilterValue: PropTypes.string,
  updateSelectedFilterValue: PropTypes.func,
  type: PropTypes.oneOf([
    'both',
    'selectOnly',
    'tabsOnly',
  ]),
  id: PropTypes.string,
};

ResponsiveFilter.defaultProps = {
  type: 'both',
};

export default ResponsiveFilter;
